
import store from '../index.js.erb'
import _ from "lodash";
import ScholarshipMeetingVoteApi
  from "../../../components/application/scholarship/Services/Api/MeetingApi/ScholarshipMeetingVoteApi";


const ScholarshipVoteStore = {
  namespaced: true,
  state: ()=>({
    votes: [],
    selectedStatements: [],
    dialogVote: false,
  }),

  getters: {
    memberVotes(state, getters) {
      if (_.isEmpty(state.votes)) return [];

      const ids = _.map(state.votes?.memberVotes, vote => vote.votes_id);
      const statements = getters.statementsAndVotes;
      return  _.filter(statements, statement => ids.includes(statement?.id));
    },

    statementsAndVotes(state) {
      if (_.isEmpty(state.votes)) return [];

      const statements = _.cloneDeep(store.state.scholarship_competition.statements);

      return _.map(statements, (i) => {
        let statementVotes =
          _.filter(state.votes.otherMeetingVotes, vote => vote.scholarshipCompetitionId === i.id)
        return {
          ...i,
          count_votes: statementVotes?.length,
          member_votes: statementVotes
        }
      });
    },
  },

  mutations: {


    setDialogFlag(state, flag) {
      state.dialogVote = flag;
    },

    setVotes(state, response) {
      state.votes = response;
    },

    setSelectedStatements(state, selected) {
      state.selectedStatements = this.selectStatement = _.map(selected, item => item.id);
    },

  },

  actions: {
    async openDialog({commit, dispatch, state}) {
      dispatch("getMemberVotes");
      commit('setDialogFlag', true);
    },

    async closeDialog({commit}) {
      commit('setDialogFlag', false);
    },

    async sendMemberVotes({state, commit}) {
      const idMeeting = store.state.scholarship_meeting.meeting.id;
      const response = await ScholarshipMeetingVoteApi.create(idMeeting, state.selectedStatements);

      if (_.isNil(response)) return null;
      commit('setVotes', response.data.votes);
      store.dispatch('scholarship_meeting/getMeeting', store.state.scholarship_meeting.meeting.id)
    },

    async getMemberVotes({commit}) {
      const idMeeting = store.state.scholarship_meeting.meeting.id;
      const response = await ScholarshipMeetingVoteApi.index(idMeeting);

      if (_.isNil(response)) return null;

      commit('setVotes', response.data.votes)
    },

  },
}

export default ScholarshipVoteStore